import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getOilReceivedByEcoideas } from '../../actions/oilActions';

import localStorage from '../../utils/hooks/useLocalStorage';

import { OilCounterSquareIcon } from '../../assets/icons';
const OilCounter = () => {

    const dispatch = useDispatch();
    const { oilReceivedByEcoideas, isLoadingGetOilReceivedByEcoideas } = useSelector(state => state.oil);

    useEffect(() => {
        dispatch(getOilReceivedByEcoideas())
        return () => {
        }
    }, []);

    const [userName, setUserName] = useState('');
    useEffect(() => {
        if (localStorage()) {
            setUserName(localStorage()?.getItem("nameUser"));
        }
    }, [localStorage()?.getItem("nameUser")]);


    return (
        <div className='scroll-menu'>

            <div className='row width-40 margin-center text-fz-2 color-purple-dark text-center text-normal'>
                {isLoadingGetOilReceivedByEcoideas ?
                    <div className='text-bold mt-6'>
                        Cargando...
                    </div> :
                    <>
                        <div className='mt-6'>
                            <span className='text-color-primary text-bold'>Hola {userName}</span>, esto es lo que hemos logrado juntos
                        </div>

                        <OilCounterSquareIcon className='width-50 margin-center mt-10' />

                        <div className='mt-10'>
                            <span className='text-bold'>Reciclamos {oilReceivedByEcoideas} litros </span>
                            <span className='text-information-profile'>de aceite</span>
                        </div>

                        <div className='mt-6'>
                            <span className='text-bold'>Salvamos {oilReceivedByEcoideas*1000} litros </span>
                            <span className='text-information-profile'>de agua</span>
                        </div>

                        <div className='mt-6'>
                            <span className='text-bold'> {oilReceivedByEcoideas*2.5} kilogramos menos </span>
                            <span className='text-information-profile'> de CO2 emitidos</span>
                        </div>

                        <div className='mt-6'>
                            <span className='text-bold text-color-dark-green'> Gracias! </span>
                        </div>
                    </>
                }

            </div>

        </div>
    )
}

export default OilCounter